import { Types } from '@store/types';

export const _storeData = (key, value) => {
	//console.log(key, value);
	return (dispatch) => {
		dispatch({ type: Types.SET_NOTIFICATION_DATA, payload: { key: key, data: value } });
	};
};

export const setReplyData = (payload) => async (dispatch) => {
	await dispatch({
		type: Types.SET_NOTIFICATION_REPLY_COMMENT,
		payload: payload
	});
};
